import TextField from "../../../components/textField/TextField";
import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { useEffect, useRef, useState } from "react";
import { BP } from "../../../util/constants/breakpoints";
import TextArea from "../../../components/textArea/TextArea";
import FullDivider from "../../../components/fullDivider/FullDivider";
import LinksAndDetails from "../../../components/linksAndDetails/LinksAndDetails";
import { PERSONALINFO } from "../../../util/constants/personalInfo";



export default function ContactForm(){

    const mobileEmojiWidth = 32
    const desktopEmojiWidth = 36


    const [emojiWidth, setEmojiWidth] = useState(mobileEmojiWidth);

    const onWindowWidthChange = () => {
        setEmojiWidth(getEmojiWidth);
    }

    const getEmojiWidth = () => {
        if(window.innerWidth < BP.lg) return mobileEmojiWidth
        else return desktopEmojiWidth 
    }


    useEffect(() => {
        setEmojiWidth(getEmojiWidth());
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [formData, setFormData] = useState({});

    const [isMissingName, setIsMissingName] = useState(false);
    // const [isMissingEmail, setIsMissingEmail] = useState(false);

    const nameRef = useRef(null);
    // const emailRef = useRef(null);


    const handleChange = (e) => {
        const { name, value } = e.target;


        // if(name === "email" && value){
        //     setIsMissingEmail(false);
        // }

        if(name === "name" && value){
            setIsMissingName(false);
        }


        setFormData(existing => ({
            ...existing,
            [name]: value
        }));



    }

    const handleSubmit = (e) => {
        let validData = true;
        e.preventDefault();


        if(!formData.name){
            setIsMissingName(true);
            validData = false;
        }

        // if(!formData.email){
        //     setIsMissingEmail(true);
        //     validData = false;
        // }

        if(!formData.name) return nameRef.current.focus();
        // if(!formData.email) return emailRef.current.focus();

        if(validData){

            const body=`${formData.name?"Hi I'm " + formData.name:""} ${formData.company?" from " + formData.company:""},\n\n${formData.body??""}`;

            window.location.href = `mailto:${PERSONALINFO.email}?subject=${formData.subject??""}&body=${encodeURIComponent(body)}` 

            console.log(formData);
        }


    }

    return (
        <>

            <div
                className="
                    px-12
                    sm:px-28
                    lg:px-36
                    xl:px-48
                    my-16

                "
            >

                <h2
                    className="
                        flex
                        items-center

                        text-2xl
                        lg:text-3xl

                        tracking-wide
                        sm:tracking-widest

                        font-bold
                        text-body-text-light
                        dark:text-body-text-dark
                    "
                >
                    Let me know what you need!
                    &nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="smiling-face-with-sunglasses" width={emojiWidth}/>
                    </EmojiProvider>
                </h2>

                <div
                    className="
                        flex
                        justify-between
                    "
                >


                    <div
                        className="
                            xl:w-7/12
                            w-full
                        "
                    >


                        <form onSubmit={handleSubmit}>
                            <TextField
                                focusRef={nameRef}
                                name="name"
                                placeholder="John Doe *"
                                label="What's your name?"
                                changeCallback={handleChange}
                                className="
                                    my-7
                                "
                            />
                            {
                                isMissingName && (
                                    <span
                                        className="
                                            text-red-400
                                        "
                                    >
                                        Don't forget to enter your name!
                                    </span>
                                )
                            }

                            {/* <TextField
                                focusRef={emailRef}
                                name="email"
                                placeholder="johndoe@mail.com *"
                                label="Where should I mail you?"
                                changeCallback={handleChange}
                                className="
                                    my-7
                                "
                            />
                            {
                                isMissingEmail && (
                                    <span
                                        className="
                                            text-red-400
                                        "
                                    >
                                        Don't forget to enter your email!
                                    </span>
                                )
                            } */}


                            <TextField
                                name="company"
                                placeholder="Banana Inc."
                                label="Do you work for anyone?"
                                changeCallback={handleChange}
                                className="
                                    my-7
                                "
                            />


                            <TextField
                                name="subject"
                                placeholder="Need landing page..."
                                label="How can I help you?"
                                changeCallback={handleChange}
                                className="
                                    my-7
                                "
                            />


                            <TextArea
                                name="body"
                                placeholder="Hi Wei Jian, I need..."
                                label="Tell me the rest!"
                                changeCallback={handleChange}
                                className="
                                    my-7
                                "
                            />



                            <div
                                className="
                                    flex
                                    justify-center
                                    xl:justify-start
                                "
                            >


                                <button 
                                    type="submit"
                                    className="
                                        flex
                                        items-center
                                        bg-body-bg-dark
                                        dark:bg-body-bg-light
                                        text-body-text-dark
                                        dark:text-body-text-light
                                        font-semibold
                                        tracking-wider
                                        text-xl
                                        p-5
                                        rounded-3xl

                                        transition-all
                                        hover:scale-110
                                    "
                                >
                                    Send
                                    &nbsp;
                                    <EmojiProvider data={emojiData}>
                                        <Emoji className="inline" name="envelope" width={24}/>
                                    </EmojiProvider>
                                </button>


                            </div>

                        </form>


                    </div>

                    <div
                        className="max-xl:hidden"
                    >
                        <LinksAndDetails />
                    </div>


                </div>


                <div
                    className="
                        xl:hidden
                    "
                >

                    {/* <div
                        className="
                            flex
                            justify-between
                            items-center
                            my-10
                        "
                    >

                        <FullDivider />

                        <span
                            className="
                                mx-7
                                text-body-text-grey
                                text-nowrap
                            "
                        >
                            Links & Details
                        </span>

                        <FullDivider />


                    </div> */}
                    
                    <FullDivider />

                    <LinksAndDetails />

                </div>



            </div>

        </>
    );

};